import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">{contactInfo.title}</h2>
        <p className="text-sm text-foreground-500 mb-10 max-w-xl">{contactInfo.desc}</p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl">
          <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200/70">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
              <i className="ri-mail-line text-lg"></i>
            </span>
            <div className="min-w-0">
              <div className="text-xs text-foreground-400 mb-0.5">电子邮箱</div>
              <div className="text-sm font-medium text-foreground-800 truncate">{contactInfo.email}</div>
            </div>
          </div>
          <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200/70">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-green-100 text-green-600 flex-shrink-0">
              <i className="ri-wechat-line text-lg"></i>
            </span>
            <div className="min-w-0">
              <div className="text-xs text-foreground-400 mb-0.5">微信公众号</div>
              <div className="text-sm font-medium text-foreground-800 truncate">{contactInfo.wechat}</div>
            </div>
          </div>
          <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200/70">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-blue-100 text-blue-600 flex-shrink-0">
              <i className="ri-qq-line text-lg"></i>
            </span>
            <div className="min-w-0">
              <div className="text-xs text-foreground-400 mb-0.5">QQ客服</div>
              <div className="text-sm font-medium text-foreground-800 truncate">{contactInfo.qq}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}